/**
 * Position Score mapping per the product spec:
 *   Rank 1               = 100
 *   Rank 2               = 80
 *   Rank 3               = 65
 *   Rank 4–5             = 40
 *   Mentioned, unranked  = 20
 *   Not mentioned        = 0
 */
export function positionScoreForResult(params: {
  brandMentioned: boolean;
  rankPosition: number | null;
}): number {
  const { brandMentioned, rankPosition } = params;
  if (!brandMentioned) return 0;
  if (rankPosition == null) return 20;
  if (rankPosition <= 1) return 100;
  if (rankPosition === 2) return 80;
  if (rankPosition === 3) return 65;
  if (rankPosition <= 5) return 40;
  return 20; // ranked beyond 5 — mentioned but weakly placed
}
